export const blockIconsNavigationRefresh = (
	<span className='material-symbols-outlined'>refresh</span>
);
